/* eslint-disable */
<template>
</template>

<script>
export default {
  name: 'callback',
  data () {
    return {
      user_email: '',
      user_name: '',
      options:'',
      frontendUrl: '',
      frontEndUrlToUse: ''
    }
    },
    mounted: function () {
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.loginUser();
    },
    methods: {
      superUser() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_roles = this.$session.get('user_roles');
        if (user_roles && _.indexOf(user_roles, 'SuperAdmin') > -1) {
          return true;
        }
        else {
          return false;
        }
      },


      loginUser(){
      let self = this;
      console.log(`${self.frontendUrl.slice(0, -1)}${self.$route.query.backUrl}`);
      this.$axios.post(self.$root.baseUrl + '/auth/login_user/', {
         Token: self.$route.query.token
        })
        .then((res) => {
            res = res.data
            // console.log(res);
            if (res.status == 'ok') {
              var user_object = JSON.parse(res['user_object']);
              var option_object = res['options'];
              var mode = res['mode'];
              var version = res['version'];
              var release_notes = res['release_notes'];
              var eto_definition = res['eto_definition'];
              console.log(user_object);
              self.$store.commit('saveToken', { token: user_object.token, username: user_object.user_name, env: mode  });

              self.user_name = user_object.user_name;
              self.user_email = user_object.user_id;
              self.options = option_object;
              self.$session.start();
              self.$session.set('user_id', user_object.user_id);
              self.$session.set('user_name', user_object.user_name);
              self.$session.set('user_site', user_object.regions);
              self.$session.set('user_roles', user_object.roles);
              self.$session.set('user_functions', user_object.functions);
              self.$session.set('options', option_object);
              self.$session.set('release_notes', release_notes);
              self.$session.set('eto_definition', eto_definition);
              self.$session.set('mode', mode);
              self.$session.set('version', version);

              self.frontEndUrlToUse = self.$options.filters['frontendUrlbyRoles']('Home', user_object.user_name, user_object.roles, user_object.functions, user_object.regions);
              self.$session.set('frontEndUrlToUse', self.frontEndUrlToUse);

              if(self.$route.query.backUrl){
                // slice last / in  frontendUrl
                window.location.href = `${self.frontendUrl.slice(0, -1)}${self.$route.query.backUrl}`;
              } else {
                if (self.superUser() === true) {
                  self.$router.push({ path: '/admin-login' });
                }
                else {
                  self.$router.push({ path: '/home' });
                  self.$router.push('home');
                }
              }
            } else {
              self.$message.error(res.description);
              //console.log(res);
              self.$router.push({ path: '/azure-login' });
            }

        })
        .catch( function (error) {
            if (error.response) {
              console.log(error);
            }
          }
        )
      }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Callback.vue